/* eslint-disable */

import AuthServices from "./services/auth";

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

var _refreshInterval;
if (typeof window !== 'undefined') {
  var _toRefresh = localStorage.getItem('toRefresh');
}

const localAuthServices = {

  isLoggedIn() {
    var token = getCookie('token');
    if (token) {
      if (token != '') {
        return true;
      }
      return false;
    } else {
      return false;
    }
  },

  setLogin(token, refresh_token = null) {
    let _expiration = 0.5; // for 12 hours 
    // let _expiration = 1; // for 1 day
    setCookie('token', token, _expiration);
    if (refresh_token != null) {
      setCookie('refresh_token', refresh_token, _expiration);
    }
  },

  getToken() {
    return getCookie('token');
  },

  getRefreshToken() {
    return getCookie('refresh_token');
  },

  removeToken() {
    localStorage.removeItem('toRefresh');
    clearInterval(_refreshInterval);
    setCookie('token', '', 0);
    setCookie('refresh_token', '', 0);
  },

  refreshToken() {
    if (this.isLoggedIn()) {
      let token = this.getRefreshToken();
      this.setLogin(token);
    }
  },

  async refreshTokenOnLoad() {
    let _token = this.getRefreshToken();
      try {
        var response = await AuthServices.refreshToken({ 'refresh': _token });
        let _newToken = response.data.access;
        this.setLogin(_newToken);
        console.log('Token refreshed');
      } catch (error) {
        console.log(error);
      }
  },

  setTokenExpiration() {
    _refreshInterval = setInterval(async () => {
      let _token = this.getRefreshToken();
      try {
        var response = await AuthServices.refreshToken({ 'refresh': _token });
        let _newToken = response.data.access;
        this.setLogin(_newToken);
        console.log('Token refreshed every 15 minutes');
      } catch (error) {
        console.log(error);
      }
    }, 10000 * 6 * 15);
  }
}

if (_toRefresh) {
  localAuthServices.setTokenExpiration();
}

export default localAuthServices;
